export default __webpack_public_path__ + "static/media/logoCombustion.51eacccb.png";